interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
    strokeWidth?:string;
}

export const Close = ({
    width = 19,
    height = 16,
    hexColor = 'black',
    strokeWidth ='0.5px'
}: Props) => {

    return (
        <svg width={width} height={height} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <title>{'Close'}</title>
            <g id="Group 11254">
            <rect id="Rectangle 405" x="9.68359" y="0.646447" width="0.896142" height="12.7804" transform="rotate(45 9.68359 0.646447)" fill={hexColor} stroke={hexColor} strokeWidth={strokeWidth}/>
            <rect id="Rectangle 406" x="10.4336" y="9.68359" width="0.896142" height="12.7804" transform="rotate(135 10.4336 9.68359)" fill={hexColor} stroke={hexColor} strokeWidth={strokeWidth}/>
            </g>
        </svg>
    );
};

export default Close;
